import { render } from "./ClassMsgDialog.vue?vue&type=template&id=933a0226"
import script from "./ClassMsgDialog.vue?vue&type=script&lang=js"
export * from "./ClassMsgDialog.vue?vue&type=script&lang=js"

import "./ClassMsgDialog.vue?vue&type=style&index=0&id=933a0226&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__